import { useEffect, useRef } from "react";
import { useAuth } from "../lib/auth";
import { useT } from "../lib/i18n";

/**
 * On login, apply the rep's saved `default_language` to the i18n context exactly once per
 * session. We track the user id so a logout/login as a different rep re-applies their
 * preference, but we don't fight the user if they manually flip the language picker.
 */
export default function UserLanguageSync() {
  const { user } = useAuth();
  const { lang, setLang } = useT();
  const appliedFor = useRef(null);

  useEffect(() => {
    if (!user || !user.id) return;
    if (appliedFor.current === user.id) return;
    appliedFor.current = user.id;
    const pref = user.default_language;
    if (pref && pref !== lang) setLang(pref);
    // We intentionally don't include `lang` in deps — we sync once per user, then leave
    // manual picker changes alone.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, user?.default_language]);

  return null;
}
